<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col cols="4">
					<!--					<b-form-select v-model="departmentId" name="departmentId" :disabled="allDeps">-->
					<!--						<option v-for="(selectOption, indexOpt) in departments" :key="indexOpt" :value="selectOption.id">{{ selectOption.name }}</option>-->
					<!--						<template slot="first">-->
					<!--							<option :value="null" disabled>-->
					<!--								&#45;&#45; {{ $t('priceControl.departments') }} &#45;&#45;-->
					<!--							</option>-->
					<!--						</template>-->
					<!--					</b-form-select>-->
					<multiselect label="name" track-by="id" v-model="departmentId" :multiple="true"
						:options="departments" :allow-empty="true" :group-select="true" :show-labels="false"
						class="multiselect-pricing" :placeholder="$t('goods.create.select-group')" />
				</b-col>
				<b-col cols="2">
					<date-picker v-model="fromDate" lang="ru" style="width: 100%"
						:placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col cols="2">
					<date-picker v-model="toDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.toDate')"
						value-type="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col>
					<b-form-input v-model="barcode" :placeholder="$t('goods.special-barcode')" />
				</b-col>
			</b-row>
			<b-row class="mt-1 mb-2">
				<b-col cols="2">
					<b-checkbox v-model="allDeps" switch>
						{{ $t("Whole_firm") }}
					</b-checkbox>
				</b-col>
				<b-col>
					<b-form-input v-model="itemName" :placeholder="$t('goods.name')" />
				</b-col>
				<b-col cols="3">
					<b-input-group class="shodowed-group">
						<b-form-select v-model="contractorCategoryId" :options="contractorCategories"
							:value-field="'id'" :text-field="'name'" size="sm" id="categoryFilter">
							<template slot="first">
								<option :value="null" disabled>
									{{ $t('contragent.search-category') }}
								</option>
							</template>
						</b-form-select>
						<b-input-group-append>
							<b-input-group-addon>
								<b-button type="button" size="sm" variant="outline-default"
									@click="contractorCategoryId = null" v-b-tooltip.hover
									:title="$t('contragent.clear')">
									<i class="fa fa-close" />
								</b-button>
							</b-input-group-addon>
						</b-input-group-append>
					</b-input-group>
				</b-col>
				<b-col cols="2">
					<b-button @click="getItems" variant="dark" class="fa fa-search mr-3" />
					<b-button @click="print" variant="outline-dark" class="fa fa-print" />
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<multiselect label="name" track-by="id" v-model="group" :multiple="true" :options="groups"
						:allow-empty="true" :group-select="true" :show-labels="false" class="multiselect-pricing"
						:placeholder="$t('goods.create.select-group')" />
				</b-col>
				<b-col>
					<multiselect label="name" track-by="id" :multiple="true" v-model="category" :allow-empty="true"
						:group-select="true" :show-labels="false" :options="categorys" class="multiselect-pricing"
						:placeholder="$t('goods.create.category')" />
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<multiselect label="name" track-by="id" v-model="group1" :multiple="true" :options="groups"
						:allow-empty="true" :group-select="true" :show-labels="false" id="danger-multiselect"
						:placeholder="$t('Except_group')" class="multiselect-pricing danger-multiselect" />
				</b-col>
				<b-col>
					<multiselect label="name" track-by="id" :multiple="true" v-model="category1" :allow-empty="true"
						:group-select="true" :show-labels="false" :options="categorys1"
						class="multiselect-pricing danger-multiselect" :placeholder="$t('Except_category')" />
				</b-col>
				<b-col>
					<multiselect v-model="sellers" :options="employees" label="name" track-by="id" :multiple="true"
						:allow-empty="true" :show-labels="false" class="multiselect-pricing"
						:custom-label="sellerCustomLabel" @search-change="getEmployees($event)"
						:placeholder="$t('sidebar.organization-structure.employees')">
						<template slot="option" slot-scope="option">
							{{ sellerCustomLabel(option.option) }}
						</template>
					</multiselect>
				</b-col>
			</b-row>
			<hr class="mt-4">
		</div>
		<b-card-body id="print_certificate">
			<b-row>
				<b-col cols="3">
					<div style="font-size: 12px"><b>DutyFree International</b></div>
				</b-col>
				<b-col cols="6" class="text-center">
					<h6><b>{{ $t("Sales_by_groups_of_money_change") }} {{ $t("c") }} {{ fromDate ? fromDate : '________'
					}}
							{{ $t("po") }}{{ toDate ? toDate : '________' }}</b></h6>
				</b-col>
				<b-col class="text-right"></b-col>
			</b-row>
			<b-row>
				<b-col>
					<b style="font-size: 12px">{{ $t('pricing.department') }}: {{ departmentId ? depName :
						'__________________'
					}}</b>
				</b-col>
			</b-row>
			<b-row class="mt-5 mb-4">
				<b-col>
					<table id="gridContainer" class="b-table table-striped table-hover table-bordered"
						style="font-size: 11px; width: 100%; padding: 0">
						<thead>
							<tr>
								<th class="text-center" style="font-size: 10px; width: 3%">№</th>
								<th v-if="fields.barcode" class="text-center" style="font-size: 10px;">
									{{ $t('goods.special-barcode') }}</th>
								<th v-if="fields.name" class="text-center" style="font-size: 10px;">{{ $t('name') }}
								</th>
								<th v-if="fields.remaining" class="text-center" style="font-size: 10px;">
									{{ $t('remaining') }}
								</th>
								<th v-if="fields.sold" class="text-center" style="font-size: 10px;">{{ $t("sold") }}
								</th>
								<th v-if="fields.Selling_amounts" class="text-center" style="font-size: 10px;">
									{{ $t("Selling_amounts") }}</th>
								<th v-if="fields.Prod_in_soums" class="text-center" style="font-size: 10px;">
									{{ $t("Prod_in_soums") }}</th>
							</tr>
						</thead>
						<tbody v-for="(item, index) in items" :key="`items-${index}`" style="padding: 0; margin: 0">
							<tr class="text-left">
								<td :colspan="fields.barcode ? 7 : 7"><b>Группа: </b>{{ item.groupName }}</td>
							</tr>
							<tr class="text-center" v-for="(sub, i) in item.subGroups" :key="`sub-${i}`"
								style="padding: 0; margin: 0">
								<td :colspan="fields.barcode ? 7 : 7">
									<b>Подгруппа: </b><i>{{ sub.supGroupName }}</i>
									<table class="b-table table-striped table-hover table-bordered"
										style="width: 100%; padding: 0; margin: 0">
										<tr v-for="(tmp, ind) in sub.saleItems" :key="`saleItems-${ind}`">
											<td class="text-center" style="font-size: 10px; width: 3%">{{ ind + 1 }}
											</td>
											<td v-if="fields.barcode" class="text-center" style="font-size: 10px;">{{
												tmp.barcode }}</td>
											<td v-if="fields.name" class="text-left" style="font-size: 10px;">{{
												tmp.itemName }}
											</td>
											<td v-if="fields.remaining" class="text-center" style="font-size: 10px">{{
												tmp.remaning }}</td>
											<td v-if="fields.sold" class="text-center" style="font-size: 10px;">{{
												tmp.saleCount
											}}</td>
											<td v-if="fields.Selling_amounts" class="text-center"
												style="font-size: 10px; ">{{
													tmp.price | currency({
														symbol: '', fractionCount: 2, symbolPosition:
															'back',
														thousandsSeparator: ' '
													}) }}</td>
											<td v-if="fields.Prod_in_soums" class="text-center"
												style="font-size: 10px;">{{
													tmp.priceUzs | currency({
														symbol: '', fractionCount: 2, symbolPosition:
															'back',
														thousandsSeparator: ' '
													}) }}</td>
										</tr>
										<tr>
											<td :colspan="fields.barcode && fields.name ? 3 : 1" class="text-right">
												<b>Итого:
												</b>
											</td>
											<td v-if="fields.remaining" class="text-center"><b>{{ sumRemaining(sub)
											}}</b></td>
											<td v-if="fields.sold" class="text-center"><b>{{ sumSaleCount(sub) }}</b>
											</td>
											<td v-if="fields.Selling_amounts" class="text-center"><b>{{ sumPrice(sub) |
												currency({
													symbol: '', fractionCount: 2, symbolPosition: 'back',
													thousandsSeparator: ' '
												}) }}</b></td>
											<td v-if="fields.Prod_in_soums" class="text-center"><b>{{ sumPriceUzs(sub) |
												currency({
													symbol: '', fractionCount: 2, symbolPosition: 'back',
													thousandsSeparator: ' '
												}) }}</b></td>
										</tr>
									</table>
								</td>
							</tr>
							<tr>
								<td colspan="3" class="text-right"><b>Итого по {{ item.groupName }}:</b></td>
								<td v-if="fields.remaining" class="text-center"><b>{{ itogoSumRemaining(item) }}</b>
								</td>
								<td v-if="fields.sold" class="text-center"><b>{{ itogoSumSaleCount(item) }}</b></td>
								<td v-if="fields.Selling_amounts" class="text-center"><b>{{ itogoSumPrice(item) |
									currency({
										symbol: '', fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator: ' '
									}) }}</b></td>
								<td v-if="fields.Prod_in_soums" class="text-center"><b>{{ itogoSumPriceUzs(item) |
									currency({
										symbol: '', fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator: ' '
									}) }}</b></td>
							</tr>
						</tbody>
						<tr v-if="items.length > 0">
							<td colspan="3" class="text-right"><b>Всего:</b></td>
							<td v-if="fields.remaining" class="text-center"><b>{{ vsegoRemaining(items) }}</b></td>
							<td v-if="fields.sold" class="text-center"><b>{{ vsegoSaleCount(items) }}</b></td>
							<td v-if="fields.Selling_amounts" class="text-center"><b>{{ vsegoPrice(items) |
								currency({
									symbol:
										'', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</b></td>
							<td v-if="fields.Prod_in_soums" class="text-center"><b>{{ vsegoPriceUzs(items) |
								currency({
									symbol:
										'', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
								}) }}</b></td>
						</tr>
						<tr v-else>
							<td class="text-center" colspan="7">
								<h4>{{ $t('empty') }}</h4>
							</td>
						</tr>
						<tr v-if="loading">
							<td colspan="7" class="text-center">
								<b-spinner small class="mr-2" /><strong>Loading...</strong>
							</td>
						</tr>
					</table>
					<b-button v-if="items.length > 0" class="float-right mt-1 hidden-print"
						@click="excelExport1('gridContainer', 'Отчет № 16')" variant="primary" :disabled="loading">{{
							$t('excel-export.download-excel') }}</b-button>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import UsersService from "../../../services/users.sevice";
import { TokenService } from "../../../services/storage.service";
import ReportService from "./report.service";
import Multiselect from "vue-multiselect";
import ReferencesService from "../../../services/references.sevice";

export default {
	name: "Продажы по группам",
	components: { Multiselect },
	data() {
		return {
			fields: {
				barcode: true,
				name: true,
				remaining: true,
				sold: true,
				Selling_amounts: true,
				Prod_in_soums: true,
			},
			items: [],
			departments: [],
			departmentId: null,
			fromDate: null,
			toDate: null,
			itemName: '',
			barcode: '',
			sellers: [],
			employees: [],
			departmentIds: [],
			group: null,
			group1: null,
			category: null,
			category1: null,
			contractorCategoryId: null,
			contractorCategories: [],
			groups: [],
			categorys: [],
			categorys1: [],
			groupIds: [],
			groupNots: [],
			categoryIds: [],
			subGroupNots: [],
			allDeps: false,
			loading: false
		}
	},
	watch: {
		allDeps: {
			handler(e) {
				if (e)
					this.departmentId = null
			}
		},
		'group': {
			handler(g) {
				this.groupIds = []
				g.filter(t => this.groupIds.push(t.id))
				if (this.groupIds.length > 0) {
					ReferencesService.getCategorysByGroupIds(this.groupIds).then(res => {
						this.categorys = res.data
					})
				} else {
					this.categorys = []
				}
				this.category = null
			}
		},
		'departmentId': {
			handler(g) {
				this.departmentIds = []
				g.filter(t => this.departmentIds.push(t.id))
			}
		},
		'category': {
			handler(c) {
				this.categoryIds = []
				c.filter(t => this.categoryIds.push(t.id))
			}
		},
		'group1': {
			handler(g) {
				this.groupNots = []
				g.filter(t => this.groupNots.push(t.id))
				if (this.groupNots.length > 0) {
					ReferencesService.getCategorysByGroupIds(this.groupNots).then(res => {
						this.categorys1 = res.data
					})
				} else {
					this.categorys1 = []
				}
				this.category1 = null
			}
		},
		'category1': {
			handler(c) {
				this.subGroupNots = []
				c.filter(t => this.subGroupNots.push(t.id))
			}
		}
	},
	computed: {
		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		}
	},
	methods: {
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function (s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function (s, c) {
					return s.replace(/{(\w+)}/g, function (m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		print() {
			const prtHtml = document.getElementById("print_certificate").innerHTML;
			let stylesHtml = "";
			for (let node of [
				...document.querySelectorAll('link[rel="stylesheet"], style'),
			]) {
				stylesHtml += node.outerHTML;
			}
			// Open the print window
			const WinPrint = window.open(
				"",
				"",
				"left=0,top=0,width=1000,height=1000,toolbar=0,scrollbars=0,status=0"
			);
			let html = `<!DOCTYPE html>
					<html>

					  <head>
					  <style>
					body {
					  color: #000 !important;
					  align-items: flex-start;
					}
					#print_certificate {
					  display: block;
					}
					img.shadow {
					  box-shadow: none !important;
					}
						 table ,tr,td,th {
  						border: rgba(0,0,255,0.25) solid !important;
					}
					table {
             border-collapse: collapse !important;
            }
					</style>
						${stylesHtml}
					  </head>
					  <body>
						${prtHtml}

					  </body>
					</html>`;
			WinPrint.document.write(html);
			WinPrint.print();
		},
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		async getEmployees(search) {
			await UsersService.getSellerEmployees(search).then(response => {
				this.employees = response.data
			})
		},
		sellerCustomLabel(seller) {
			return (
				seller.firstName +
				" " +
				seller.lastName +
				" " +
				seller.middleName
			);
		},
		getItems() {
			this.loading = true
			this.items = []
			if (this.fromDate && this.toDate && this.sellers.length !== 0) {
				if (this.departmentId || this.allDeps) {
					let data = {
						endDate: this.toDate,
						value: this.itemName,
						allDeps: this.allDeps,
						groups: this.groupIds,
						barcode: this.barcode,
						startDate: this.fromDate,
						deps: this.departmentIds,
						groupNots: this.groupNots,
						subGroups: this.categoryIds,
						subGroupNots: this.subGroupNots,
						sellers: this.sellers.map(item => item.id),
						contractorCategoryId: this.contractorCategoryId
					}
					ReportService.getSaleItemsWithGroupByUsername(data).then(res => {
						this.items = res.data
						this.loading = false
					}).catch(e => {
						this.loading = false
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				} else {
					this.loading = false
					this.$vs.notify({
						text: "Выберите Подразделение с периодом",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите разделение по периоду и сотруднику",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		},
		sumRemaining(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum += tmp.remaning
			})
			return sum
		},
		sumSaleCount(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum += tmp.saleCount
			})
			return sum
		},
		sumPrice(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum += parseFloat(tmp.price.toFixed(2))
			})
			return sum
		},
		sumPriceUzs(item) {
			let sum = 0
			item.saleItems.forEach(tmp => {
				sum += parseFloat(tmp.priceUzs.toFixed(2))
			})
			return sum
		},
		itogoSumRemaining(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum += t.remaning
				})
				itog += sum
			})
			return itog
		},
		itogoSumSaleCount(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum += t.saleCount
				})
				itog += sum
			})
			return itog
		},
		itogoSumPrice(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum += parseFloat(t.price.toFixed(2))
				})
				itog += sum
			})
			return itog
		},
		itogoSumPriceUzs(item) {
			let itog = 0
			item.subGroups.forEach(ite => {
				let sum = 0
				ite.saleItems.forEach(t => {
					sum += parseFloat(t.priceUzs.toFixed(2))
				})
				itog += sum
			})
			return itog
		},
		vsegoRemaining(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum += t.remaning
					})
					itog += sum
				})
				vsego += itog
			})
			return vsego
		},
		vsegoSaleCount(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum += t.saleCount
					})
					itog += sum
				})
				vsego += itog
			})
			return vsego
		},
		vsegoPrice(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum += parseFloat(t.price.toFixed(2))
					})
					itog += sum
				})
				vsego += itog
			})
			return vsego
		},
		vsegoPriceUzs(tmp) {
			let vsego = 0
			tmp.forEach(item => {
				let itog = 0
				item.subGroups.forEach(ite => {
					let sum = 0
					ite.saleItems.forEach(t => {
						sum += parseFloat(t.priceUzs.toFixed(2))
					})
					itog += sum
				})
				vsego += itog
			})
			return vsego
		}
	},
	created() {
		ReferencesService.getSubReferenceChildren(14).then(res => {
			this.groups = res.data
		}).catch(e => {
			this.$vs.notify({
				title: e.message,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		})
		ReferencesService.getReferenceChildren('CONTRAGENT_CATEGORY').then(res => {
			this.contractorCategories = res.data
		}).catch(e => {
			this.$vs.notify({
				title: e.message,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		})
		this.getDeps();
		this.getEmployees('');
	}
}
</script>

<style scoped lang="scss">
@page {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}

	.nav {
		display: none;
	}

	.nav-pills {
		display: none;
	}

	.flex-column {
		display: none;
	}
}
</style>
